<template>
  <page :title="i18n.title">
    <div class="coupon-warp">
      <div v-for="(item, index) in items" :key="index" class="coupon-item">
        <img src="@/assets/imgs/coupon_card.png" alt="">
        <div class="coupon-info">
          <div class="coupon-title">{{ item.ruleName }}</div>
          <div>{{ i18n.expires }}: {{ item.pEnd | dateFmt('DD/MM/YYYY') }}</div>
        </div>
      </div>
    </div>
    <div class="coupon-btn">
      <div class="btn" @click="isAddCoupon = true">{{ i18n.coupon_btn }}</div>
      <div class="coupon-tips">{{ i18n.coupon_tips }}</div>
    </div>
    <AddCoupon v-model="isAddCoupon" @refresh="loadList(1)"></AddCoupon>
  </page>
</template>

<script>
import { COUPON_LIST } from "@/apis/user"
import AddCoupon from "./AddCoupon"

export default {
  components: {
    AddCoupon
  },
  computed: {
    i18n() {
      return this.$t("coupon")
    }
  },
  data() {
    return {
      items: [],
      error: "",
      loading: false,
      isAddCoupon: false
    }
  },
  methods: {
    loadList(page = 1) {
      this.loading = true
      this.$loading(true)
      this.$get(
        COUPON_LIST,
        {
          page,
          limit: 20,
          state: 0
        },
        (resp) => {
          this.loading = false
          this.$loading(false)
          if (resp.list) {
            this.error = ""
            this.items = resp.list.records
          } else {
            this.error = this.i18n.msg_error
          }
        },
        (error) => {
          this.loading = false
          this.$loading(false)
          this.error = error
        }
      )
    }
  },
  created() {
    this.loadList()
  }
}
</script>

<style lang="less" scoped>
.coupon-warp {
  display: flex;
  flex-wrap: wrap;
  padding: 20px 6% 250px;
  .coupon-item {
    width: 46%;
    margin: 2%;
    position: relative;
    .coupon-info {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      color: #fff;
      text-align: center;
      .coupon-title {
        font-size: 32px;
        margin-top: 12px;
        font-weight: 600;
      }
    }
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
}
.coupon-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 53px 80px;
  background-color: #fff;
  .coupon-tips {
    font-size: 22px;
    color: #FFCA0E;
    text-align: center;
    padding-top: 20px;
  }
}
</style>
